module.exports = __webpack_public_path__ + "img/ceres_logo_app.00b83c0e.svg";